// Import SVGs directly as React components for Turbopack
import WayakLogoBlack from './assets/wayak-main-black.svg'
import WayakLogoWhite from './assets/wayak-main-white.svg'
import Favicon from './assets/favicon.svg'
import WayakDataIcon from './assets/data-icon.svg'
import WayakAgentsIcon from './assets/agents.svg'

export const WayakAssets = {
  // Render SVGs as React components
  wayakLogoBlack: WayakLogoBlack,
  wayakLogoWhite: WayakLogoWhite,
  favicon: Favicon,
  wayakDataIcon: WayakDataIcon,
  wayakAgentsIcon: WayakAgentsIcon,
}
